<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.alteraciones_periodontales.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.ap_usuario.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtons';
import examenEstomatologicoService from '../../../../services/examenEstomatologicoService';
import examenEstomatologicoUsuarioService from '../../../../services/examenEstomatologicoUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from "../../../../components/common/utilities/toast";

export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            alteraciones_periodontales: []
        }
    },
    validations(){
        return {
            alteraciones_periodontales:{
                $each:{
                    ap_usuario:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let alteraciones_periodontales_usuario = [];

                this.alteraciones_periodontales.forEach((x) => {
                    if (x.ap_usuario.valor !== "") {
                        alteraciones_periodontales_usuario.push({ ...x.ap_usuario });
                    }
                });

                this.LoaderSpinnerShow();
                await examenEstomatologicoUsuarioService.storeAlteracionPeriodontalUsuario({
                    alteraciones_periodontales_usuario: alteraciones_periodontales_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: "success",
                    title: "Datos guardados con éxito",
                });
            } catch (error) {
                console.log(error);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: "error",
                    title: "Ha ocurrido un error al procesar la solicitud",
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await examenEstomatologicoService.indexAlteracionPeriodontal({
            params: filter
        });

        const alteraciones_periodontales_usuario = await examenEstomatologicoUsuarioService.indexAlteracionPeriodontalUsuario(
            this.usuario.id
        );

        this.alteraciones_periodontales = response.data.map((y) => {
            const indice = alteraciones_periodontales_usuario.data.findIndex(
                (a) => a.id_alteracion === y.id
            );
            y.ap_usuario = {
                id: indice !== -1 ? alteraciones_periodontales_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_alteracion: y.id,
                valor: indice !== -1 ? alteraciones_periodontales_usuario.data[indice].valor : "",
            };
            return y;
        });
    }

}
</script>